import {
  TTranslation,
} from './item-generic-settings.ts';

import {
  EAppId,
} from '@/types/app-type.ts';
import {
  ESettingsSectionType,
} from '@/types/settings.ts';

const translation: TTranslation = {
  [EAppId.TENANT_SETTINGS]: {
    [ESettingsSectionType.APP_OVERVIEW]: {
      title: 'App Overview',
      subtitle: 'The following settings define the app overview, the app sidebar and the permission tree of the user management for every user.',
      settingsMap: {
        appGrouping: {
          label: 'App grouping',
          tooltip: 'Defines by which groups the apps are arranged for every user.',
          choices: {
            Department: {
              title: 'By department',
              details: 'Production planning, Operations, Quality assurance, Analytics, Master data, Administration',
            },
            Topic: {
              title: 'By topic',
              details: 'Operation, Process, Data/Insight, Maintenance, Configuration',
            },
          },
        },
      },
    },
  },
  [EAppId.REMOTE_CONTROL]: {
    [ESettingsSectionType.REMOTE_CONTROL_PT9800]: {
      title: 'PT9800 Controller',
      subtitle: 'The following settings define how the PT9800 controller behaves for every user.',
      settingsMap: {
        enforceBarcodeScanner: {
          label: 'Forcing barcode scanners.',
          tooltip: 'If selected, the confirmation of parts via barcode scanner is forced in the dialog for starting jobs.',
        },
      },
    },
  },
};

export default translation;
